// Third Party
import { catchError, map, mergeMap } from "rxjs/operators";
import { from, of } from "rxjs";
import { ofType } from "redux-observable";

// Project
import { ccAddressUpdateFailure, ccAddressUpdateSuccess } from "../../actions/draftCcActions";
import { DRAFT_CC_ADDRESSEES_UPDATE_START } from "../../constants/ActionTypes";

// Third parameter of epic is the "dependencies" property on the epic options passed to createEpicMiddleware()
const ccAddressUpdateStartEpic = (action$, state$, { messagingClient }) => action$.pipe(
  ofType(DRAFT_CC_ADDRESSEES_UPDATE_START),
  mergeMap(action => from(
    messagingClient.putMailboxDraftCcAddressees(
      action.mailboxAddress,
      action.draftIdentity,
      state$.value.messaging.draftView.cc.workingAddressees
    ))
    .pipe(
      map(response => ccAddressUpdateSuccess(action.mailboxAddress, action.draftIdentity, response.ccAddresses)),
      catchError(error => of(ccAddressUpdateFailure(action.mailboxAddress, action.draftIdentity, error)))
    )
  )
);

export default ccAddressUpdateStartEpic;
